class SsoForgotPassword extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()
  }

  setupListeners () {
    super.setupListeners()

    this.handleFormSubmit = this.handleFormSubmit.bind(this)

    this.listeners.add(this.els.form.element, 'submit', this.handleFormSubmit)
  }

  async handleFormSubmit (event) {
    event.preventDefault()

    try {
      await fetch(window.theme.sso.resetPassword, {
        method: 'POST',
        body: window.BAO.Utils.serialize(this.els.form.element),
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
      })

      this.els.success.element.setAttribute('aria-hidden', false)
      this.els.fields.element.setAttribute('aria-hidden', true)
      this.els.errors.element.setAttribute('aria-hidden', true)
    } catch (error) {
      this.els.errors.element.innerHTML = `<p class="frm-Form_ValidationText frm-Form_ValidationText-error">${window.theme.sso.error}</p>`
      this.els.errors.element.setAttribute('aria-hidden', false)

      throw new Error('Could not reset password', error)
    }
  }
}

if (!customElements.get('sso-forgot-password')) {
  customElements.define('sso-forgot-password', SsoForgotPassword)
}
